import React, { Component } from "react";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';

class NoSlotDialog extends Component {
    render() {
        return (
            <Dialog
                open={this.props.showNoSlotDialog}
                onClose={() => this.props.handleNoSlotDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    It seems that this doctor won't be available anytime soon. You may revisit this page from time to time to check for cancellations by other patients, or call this doctor for further checking.
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={() => this.props.handleNoSlotDialog(false)} color="primary">
                    Ok
                </Button>
                </DialogActions>
            </Dialog>
        )};
    }

export { NoSlotDialog };
